const CoreSetting = {
  paysystemTable: {
    id: 'ID',
    name: "Ім'я",
    active: 'Активний',
    paysystems: 'Платіжні системи',
    showing: 'показується',
    noPaysystemsFound: 'Платіжних систем не знайдено',
  },
  emailTemplatesTable: {
    id: 'ID',
    name: "Ім'я",
    active: 'Активний',
    emailTemplates: 'Сповіщення електронною поштою',
    showing: 'показується',
    noEmailTemplatesFound: 'Шаблони електронних листів не знайдено',
  },
  productTable: {
    name: "Ім'я",
    active: 'Активний',
    products: 'Продукти',
    showing: 'показується',
    noProductsFound: 'Продукти не знайдено',
  },
};

export default CoreSetting;
